(() => {
 const init = root => {
  const widget = root?.querySelector('#judgeme_product_reviews');
  if (!widget || widget.dataset.maulSwipeReady) return;
  widget.dataset.maulSwipeReady = 'true';
  const cleanups = [];
  const enhance = () => widget.querySelectorAll('.jdgm-rev-widg__reviews').forEach(rail => {
   if (rail.dataset.maulSwipe) return;
   rail.dataset.maulSwipe = 'true';
   const nav = document.createElement('div');
   nav.className = 'maul-review-navigation';
   nav.innerHTML = '<span>Swipe to explore</span><div><button type="button" aria-label="Previous customer review">Previous</button><span class="maul-review-position" aria-live="polite"></span><button type="button" aria-label="Next customer review">Next</button></div>';
   rail.before(nav);
   const [prev,next] = nav.querySelectorAll('button');
   const position = nav.querySelector('.maul-review-position');
   const cards = () => [...rail.children].filter(c => c.classList.contains('jdgm-rev'));
   const index = () => {
    const left = rail.getBoundingClientRect().left;
    let best = 0, distance = Infinity;
    cards().forEach((c,i) => {const d = Math.abs(c.getBoundingClientRect().left-left);if(d<distance){best=i;distance=d;}});
    return best;
   };
   const update = () => {
    const count=cards().length, active=index();
    nav.hidden = count < 2;
    const label = `${count ? active+1 : 0} / ${count}`;
    if(position.textContent!==label) position.textContent=label;
    prev.disabled=active===0; next.disabled=active>=count-1;
   };
   const move = direction => {
    const list=cards(), target=list[Math.max(0,Math.min(list.length-1,index()+direction))];
    if(target) rail.scrollBy({left:target.getBoundingClientRect().left-rail.getBoundingClientRect().left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
   };
   prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
   rail.addEventListener('scroll',update,{passive:true});
   const resize=new ResizeObserver(update);resize.observe(rail);
   const contents=new MutationObserver(update);contents.observe(rail,{childList:true});
   update();cleanups.push(()=>{resize.disconnect();contents.disconnect();});
  });
  enhance();
  const observer=new MutationObserver(enhance);observer.observe(widget,{childList:true,subtree:true});
  root.addEventListener('maul:editorial-cleanup',()=>{observer.disconnect();cleanups.forEach(fn=>fn());},{once:true});
 };
 document.querySelectorAll('[data-ns-maul-collector]').forEach(init);
 document.addEventListener('shopify:section:load',event=>init(event.target.querySelector('[data-ns-maul-collector]')));
})();
